import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  app: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.background.default,
    position: 'relative',
  },
  headerWrapper: {
    '@media (min-width: 1025px)': {
      height: '124px',
    },
    '@media (max-width: 1024px)': {
      height: '56px',
    },
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  public: {
    marginLeft: 0,
  },
  publicContentContainer: {
    flex: '1 0 auto',
  },
  pageContainer: {
    display: 'flex',
    minHeight: 'calc(100vh - 125px)',
    '& > div': {
      position: 'sticky',
    },
    '& > ul': {
      position: 'fixed',
      borderRight: '1px solid #E0E0E0',
      left: -1,
    },
  },
  contained: {
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: 1024,
    margin: '0 auto',
  },
  sidebarContainer: {
    width: 256,
    flexShrink: 0,
    height: '100%',
    '& > .MuiPaper-root': {
      position: 'fixed',
      overflowX: 'hidden',
      maxWidth: '100%',
      paddingTop: '124px',
      top: '0',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  contentAndFooterContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.up('md')]: {
      width: 'calc(100% - 256px)',
    },
    '@media (min-width: 1025px)': {
      marginTop: '124px',
    },
    '@media (max-width: 1024px)': {
      marginTop: '44px',
    },
  },
  contentContainer: {
    flex: '1 0 auto',
    padding: 32,
  },
  globalHeaderDesktop: {
    top: 0,
    color: '#FFFFFF',
    width: '100%',
    height: '44px',
    display: 'flex',
    zIndex: 1,
    position: 'fixed',
    paddingRight: '24px',
    justifyContent: 'space-between',
    textDecoration: 'none',
    backgroundColor: '#212121',
  },
  globalHeaderMobile: {
    color: '#FFFFFF',
    width: '100%',
    display: 'flex',
    padding: '0px 24px 16px 16px',
    justifyContent: 'left',
    backgroundColor: '#212121',
  },
  globalHeaderItemsWrapper: {
    display: 'flex',
  },
  flexDirCol: {
    flexDirection: 'column',
  },
  margin16: {
    margin: '16px 0',
  },
  linksWrapper: {
    display: 'flex',
    alignItems: 'center',
    '&>*:not(:first-child)': {
      paddingLeft: '4px',
    },
    '& a': {
      color: '#ffffff!important',
      fontSize: '14px',
      paddingRight: '4px',
      textDecoration: 'none',
      cursor: 'pointer',
      fontWeight: '600',
      lineHeight: '20px',
      marginRight: '16px',
    },
    '& a:hover': {
      textDecoration: 'underline',
    },
    '& a:active': {
      background: 'none!important',
    },
    '& a:focus': {
      background: 'none!important',
    },
  },
  socialButtonsWrapper: {
    display: 'flex',
    alignItems: 'center',
    '& button:not(:last-child)': {
      marginRight: '16px',
    },
  },
  socialButton: {
    border: '1px solid #424242',
    width: 31,
    height: 31,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#424242!important',
    },
    '&:active': {
      backgroundColor: '#616161!important',
    },
    '& span': {
      width: 'auto!important',
    },
  },
  socialButtonIcon: {
    width: '31px!important',
    height: '31px!important',
  },
  twitterIcon: {
    width: '31px!important',
    height: '31px!important',
    marginRight: '-15px',
  },
}));
